import * as yup from "yup";

import { messagesConstants } from "@/constants";

export const updateEventDetailsFormEventDetailsUpdateEventFormSchema = yup.object({
    date: yup.date().typeError(messagesConstants.inputsMsgs.date).required(),
    ownerEmail: yup.string().email(messagesConstants.inputsMsgs.invalidEmail).required(messagesConstants.inputsMsgs.email),
    title: yup.string().required(messagesConstants.inputsMsgs.title),
});
